<template>
  <app-content class="h-panel" style="overflow: hidden">
    <div style="margin: 20px 20px 0px 20px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.voucherDate.start!==params.voucherDate.end">{{ fqFormat(params.voucherDate.start) }} 至 {{ fqFormat(params.voucherDate.end) }}</div>
        <div v-else>{{ fqFormat(params.voucherDate.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.voucherDate.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.voucherDate.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <!-- 当不启用审核的时候，这里不显示jxd -->
            <FormItem class="!pb-5px" label="审核状态"  v-if="currentAccountSets.voucherReviewed">
              <Radio v-model="params.audit" :datas="[{key:0,title:'全部'},{key:1,title:'已审核'},{key:2,title:'未审核'}]"></Radio>
            </FormItem>
            <FormItem class="!pb-5px" label="排序方式">
              <Radio v-model="params.sorting" :datas="[{key:1,title:'降序'},{key:2,title:'升序'}]"></Radio>
            </FormItem>
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right">
        <!-- jxd调整按钮顺序 -->
        <Button icon="fa fa-refresh" @click="loadList()"/>
        <template v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship' && currentAccountSets.voucherReviewed">
          <Button :loading="loading" @click="audit">审核</Button>
          <Button :loading="loading" @click="cancelAudit">反审核</Button>
        </template>
        <DropdownMenu button @clickItem="trigger" :datas="param">打印</DropdownMenu>
        <template v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'">
          <Button :loading="loading" @click="finishingOffNo">整理断号</Button>
          <Button :loading="loading" @click="batchDelete">批量删除</Button>
          <DropdownMenu button @clickItem="downloadTrigger" :datas="{all:'导出所有',checked:'导出选中'}">导出凭证</DropdownMenu>
          <Button :loading="loading" @click="doUpload">
            导入凭证
          </Button>
        </template>
      </div>
    </div>
    <div class="h-panel-body voucher-list">
      <table class="header">
        <tr>
          <th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
          <td style="width: 215px">摘要</td>
          <td>科目</td>
          <td align="right" style="width: 130px">借方金额</td>
          <td align="right" style="width: 130px">贷方金额</td>
        </tr>
      </table>
      <table style="height: 650px; overflow-y: auto;" v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>

      <div v-else style="height: 650px; overflow-y: auto;">
        <table class="details" v-for="data in datas" :key="data.id">
          <tr class="details-header">
            <th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
            <td colspan="2">日期：{{ data.voucherDate }} 凭证字号：{{ data.word }}-{{ data.code }} 
              <span v-if="currentAccountSets.voucherReviewed && data.auditMemberId">审核状态：已审核</span>
              <span v-if="currentAccountSets.voucherReviewed && !data.auditMemberId">审核状态：未审核</span>
              <template v-if="data.receiptNum > 0">
                <DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">
                  <span class="ml-8px text-hover primary-color">
                  <i class="fa fa-paperclip"></i> {{ data.receiptNum }}
                  </span>
                  <template #content>
                    <div class="w-400px">
                      <div class="h-150px">
                        <vxe-table ref="billListTable" :data="data.billList" :show-header="false" height="auto">
                          <vxe-column field="name">
                            <template #default="{row}">
                              <a :href="'/api'+row.url+'?name='+row.name" target="_blank">{{ row.name }}</a>
                            </template>
                          </vxe-column>
                        </vxe-table>
                      </div>
                    </div>
                  </template>
                </DropdownCustom>
              </template>
            </td>
            <td colspan="2" style="width:380px">
              <div class="actions flex justify-end items-center">
                <a @click="printOne(data.id)" target="_blank" class="fa fa-print">打印</a>
                <!-- <Button class="h-btn" color="yellow" @click="printOne(data.id)">打印</Button> -->
                <!-- jxd原来他用data.auditMemberId审核人id作为单据是否审核的状态标准并不严谨，通过观察，data.locked是单据是否审核的标识 -->
                <router-link @success="loadList" width="1100px" v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" class="span fa fa-edit" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
                <span v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" @click="remove(data)" class="fa fa-trash">删除</span>
                <router-link @success="loadList" width="1100px" v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" class="span fa fa-copy" :to="{name:'VoucherForm',params:{voucherId:data.id,copy:true}}">复制</router-link>
                <router-link @success="loadList" width="1100px" v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" class="span fa fa-minus-square-o" :to="{name:'VoucherForm',params: { voucherId: data.id, copy: true, redCanceling: true,redSummary:{voucherDate:data.voucherDate, word: data.word, code: data.code } } }">红冲</router-link>
                <router-link @success="loadList" width="1100px" v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" class="span fa fa-key" :to="{name:'VoucherForm',params: { originalVoucherId: data.id, originaVoucherDate: data.voucherDate, originaWord: data.word ,originaCode:data.code,insert: true } }">插入</router-link>
                <router-link class="text-hover" width="80vw" v-if="currentAccountSets.voucherReviewed && data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">
                  <i class="h-icon-completed green-color" content="已审核"></i> 查看
                </router-link>
              </div>
            </td>
          </tr>
          <tr v-for="d in data.details" :key="d.id">
            <th></th>
            <td style="width: 215px; word-break: break-all;">
              {{ d.summary }} 
              <!-- <span v-if="d.currencyName && d.currencyId !== localCurrency.id">({{ d.currencyName }}：{{ d.originalAmount }}，汇率：{{ d.exchangeRate }})</span> -->
              <template v-if="d.subject&&d.num&&d.price">
                (数量:{{ d.num }}<span class="dark4-color">{{ d.subject.unit }}</span>，单价:{{ d.price }}<span class="dark4-color">元</span>)
              </template>
              <template v-if="d.subject&&d.exchangeRate">
                (汇率:{{ d.exchangeRate }}，{{ d.currencyCode }}:{{ d.creditAmountFor ||  d.debitAmountFor || 0}})
              </template>
            </td>
            <td>{{ d.subjectName }}<span v-if="d.auxiliaryDetailId">_{{ d.auxiliaryTitle }}</span></td>
            <td align="right" style="width: 130px">{{ numFormat(d.debitAmount) }}</td>
            <td align="right" style="width: 130px">{{ numFormat(d.creditAmount) }}</td>
          </tr>
          <tr class="font-bold">
            <td></td>
            <td>合计</td>
            <td>{{ dxMoney(data.debitAmount) }}</td>
            <td align="right">{{ numFormat(data.debitAmount) }}</td>
            <td align="right">{{ numFormat(data.creditAmount) }}</td>
          </tr>
        </table>
      </div>
      <!-- <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/> -->
      <Pagination v-model="pagination" @change="currentChange" layout="pager,sizes" small align="center"/>
    </div>
    <!-- 打印组件jxd -->
    <div>
      <p>
        <Modal v-model="openModal" v-bind="styleParams">
          <printDialog :params="{subparam: printData,state:printState}" @close="openModal=false"></printDialog>
        </Modal>
      </p>
    </div>
  </app-content>
</template>

<script>
import printDialog from "@/components/PrintDialog";
import Qs from "qs";
import {mapActions, mapGetters, mapState} from 'vuex'
import {h} from 'vue'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import VoucherImport from "@/views/voucher/VoucherImport";
import manba from "manba";
import voucher from "@/api/voucher";
import {downloadBlob} from "download.js";
import FinishingOffNo from "@/views/voucher/FinishingOffNo.vue";
import {message} from "heyui.ext";
import checkout from "@api/checkout";////jxd


export default {
  name: "Voucher",
  components: {printDialog},//jxd
  data() {
    return {
      //弹出窗口组件样式
      styleParams: {
        closeOnMask: false,
        fullScreen: false,
        hasCloseIcon:true,
        middle: true,
        hasMask: true,
        hasDivider: false,
        hasCloseIcon: false,
        draggable: false
      },
      //弹窗组件传递参数
      openModal: false,
      printData:"",
      printState:1,//1全部，2选中部分

      datas: [],
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      params: {
        voucherDate: {start: null, end: null},
        sorting:1,
        audit: 0
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.voucherDate.start);
      let endDate = new Date(this.params.voucherDate.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    ...mapActions(['init']),
    currentChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    downloadTrigger(key) {
      if (key === 'all') {
        voucher.download(this.params).then((data) => {
          downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
        })
      } else {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length) {
          voucher.download({id: checked.map(value => value.id)}).then((data) => {
            downloadBlob(this.currentAccountSets.companyName + (manba().format('YYYYMMDDHHmmss')) + "凭证.xlsx", data);
          })
        } else {
          this.$Message("未选择记录");
        }
      }
    },
    printOne(id){
      this.printData = id;
      this.printState = 0;
      this.openModal = true;
    },
    printAll() {
      let param = Qs.stringify({audit: this.params.audit, voucherDateStart: this.params.voucherDate.start, voucherDateEnd: this.params.voucherDate.end}, {indices: false});
      this.printData = param;
      this.printState = 1;
      this.openModal = true;
      // window.open(`/api/pdf/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        this.printData = param;
        this.printState = 2;
        this.openModal = true;
        // window.open(`/api/pdf/voucher?${param}&alignment=right`);
      } else {
        this.$Message("未选择记录");
      }
    },
    loadList() {
      const loadId = layer.load(2);
      voucher.list(this.pagination, this.params).then(({data}) => {
        this.datas = data.results || [];
        this.pagination = {
          page: data.page,
          size: data.size,
          total: data.total
        }
        this.$refs.paramsDropdown.hide()
      }).finally(() => layer.close(loadId))
    },
    //jxd通过查询已经结账的月份，判断凭证是否可以删除
    loadClosedMonthList() {
      return checkout.list().then(({ data }) => {  
        // const filteredData = data.filter(item => item.status !== 0); 
        // 0是从未结账，1是已经反结账的，2是目前已经结账的 
        const filteredData = data.filter(item => item.status !== 0 && item.status !== 1);
        console.log(filteredData)
        return filteredData;  
      });  
		},
    //jxd先检测所选凭证是否可以删除，不能删除的直接过滤掉，就不提交了
    isDeleteCheck(data){
      //第一步先判断是否启用审核，如果启用审核，则先检测要删除的凭证是否审核
      if(this.currentAccountSets.voucherReviewed){
        //启用审核，先检测所选择的凭证是否审核了
        let arrayData = [];
          //这里判断data是不是数组
          if(Array.isArray(data)){
            data.forEach(item => {
              arrayData.push(item);
            })
          }else{
            arrayData.push(data);
          }
          console.log(arrayData);
          let auditDataArray = [];
          arrayData.forEach(item => {
            //如果凭证的年月与已结账月份相同，则不可以删除
            if(item.auditMemberId){
              //已经审核的凭证存储到数组中
              auditDataArray.push({
                // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                id: item.id,
                code: item.code,
                word: item.word,
                year: item.year,
                month: item.month
              });
            }
          });
          if(auditDataArray.length > 0){
            //所选凭证有启用审核的
            auditDataArray.forEach(item => {
              this.$Message({
                type:"warn",
                text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month} 已经审核，不可删除，请先反审核或重新选择要删除的凭证！`
              });
            });
          }else{
            //没有启用审核，直接进行账套期间检测
            return this.loadClosedMonthList().then(filteredData => {
              let arrayData = [];
              //这里判断data是不是数组
              if(Array.isArray(data)){
                data.forEach(item => {
                  arrayData.push(item);
                })
              }else{
                arrayData.push(data);
              }
              console.log(arrayData);
              //arrayData凭证数组 filteredData结账数组 matchedData不可删除的单独数组
              let matchedData = [];
              for(let i = 0;i<arrayData.length;i++){
                for(let j = 0;j<filteredData.length;j++){
                  // 如果找到匹配项（即凭证的年月与已结账月份相同）
                  if (filteredData[j].checkYear === arrayData[i].year && filteredData[j].checkMonth === arrayData[i].month) {
                    // 将匹配项添加到新数组中
                    matchedData.push({
                      // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                      id: arrayData[i].id,
                      code: arrayData[i].code,
                      word: arrayData[i].word,
                      year: arrayData[i].year,
                      month: arrayData[i].month
                    });
                    arrayData.splice(i, 1);
                    i--;
                    break;
                  }  
                }
              }
              // 输出所有不能删除的凭证信息,和可以删除的凭证信息数组
              let flg;
              // let flg = arrayData.length === 0 ? false : true;
              if(arrayData.length === 0 && matchedData.length !== 0){
                //只有不能删除的
                flg = 1;
              }else if(arrayData.length !== 0 && matchedData.length === 0){
                //只有可以删除的
                flg = 2;
              }else{
                //有可以删除的和不能删除的
                flg = 3;
              }
              let res = {"isDelete":arrayData,"noDelete":matchedData,"flg":flg}
              console.log(res)
              return res;
            });  
          }
      }else{
        //没有启用审核，直接进行账套期间检测
        return this.loadClosedMonthList().then(filteredData => {
          let arrayData = [];
          //这里判断data是不是数组
          if(Array.isArray(data)){
            data.forEach(item => {
              arrayData.push(item);
            })
          }else{
            arrayData.push(data);
          }
          console.log(arrayData);
          //arrayData凭证数组 filteredData结账数组 matchedData不可删除的单独数组
          let matchedData = [];
          for(let i = 0;i<arrayData.length;i++){
            for(let j = 0;j<filteredData.length;j++){
              // 如果找到匹配项（即凭证的年月与已结账月份相同）
              if (filteredData[j].checkYear === arrayData[i].year && filteredData[j].checkMonth === arrayData[i].month) {
                // 将匹配项添加到新数组中
                matchedData.push({
                  // 可以选择性地包含一些凭证信息，例如id或整个firstItem
                  id: arrayData[i].id,
                  code: arrayData[i].code,
                  word: arrayData[i].word,
                  year: arrayData[i].year,
                  month: arrayData[i].month
                });
                arrayData.splice(i, 1);
                i--;
                break;
              }  
            }
          }
          // 输出所有不能删除的凭证信息,和可以删除的凭证信息数组
          let flg;
          // let flg = arrayData.length === 0 ? false : true;
          if(arrayData.length === 0 && matchedData.length !== 0){
            //只有不能删除的
            flg = 1;
          }else if(arrayData.length !== 0 && matchedData.length === 0){
            //只有可以删除的
            flg = 2;
          }else{
            //有可以删除的和不能删除的
            flg = 3;
          }
          let res = {"isDelete":arrayData,"noDelete":matchedData,"flg":flg}
          console.log(res)
          return res;
        });  
      }
    },
    //jxd删除凭证
    remove(row) {
      console.log(row)
      this.$Confirm("确认删除?").then(() => {
        // 需要将异步操作转换为同步处理，使用async/await
        (async () => {
          let res = await this.isDeleteCheck(row);
          if(res.flg == 2){
            ///有可以删除的
            const loadId = layer.load(2);
            voucher.delete([pick(row, ['id', 'year', 'month',"word","code"])]).then(({data}) => {
              this.$Message("删除成功~")
              this.init();
              this.loadList();
            }).finally(() => layer.close(loadId))
          }else if(res.flg == 1){
            //没有可以删除的
            res.noDelete.forEach(item => {
              this.$Message({
                type:"warn",
                text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month} 期间已结账，不能删除~`
              });
            });
          }
        })();
      });
    },
    finishingOffNo() {
      let layerId = layer.open({
        title: "断号整理",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['400px', 'auto'],
        content: h(FinishingOffNo, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList();
          }
        })
      });
    },
    //jxd批量删除凭证修复
    batchDelete() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        this.$Confirm("确认删除?").then(() => {
          (async () => {
            let res = await this.isDeleteCheck(checked);
            if(res.flg == 2){
              const loadId = layer.load(2);
              this.$api.voucher.delete(checked.map(val => pick(val, ['id', 'year', 'month']))).then(({data}) => {
                this.$Message("删除成功~")
                this.init();
                this.loadList();
              }).finally(() => {
                layer.close(loadId);
              });
            }else if(res.flg == 1){
              //没有可以删除的
              res.noDelete.forEach(item => {
                this.$Message({
                  type:"warn",
                  text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month} 期间已结账，不能删除~`
                });
              });
            }else {
              //有能删除有不能的提醒去除不可删除的
              res.noDelete.forEach(item => {
                this.$Message({
                  type:"warn",
                  text: `凭证号${item.word}-${item.code}期间${item.year}-${item.month}，所选择的期间已结账，不能删除，请去除不可删除的凭证后再进行批量删除~`
                });
              });
            }
          })();
        });
      } else {
        message.warn("没有可删除凭证~");
      }
    },
    audit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const vdates = new Set(checked.map(val => val.year + "" + val.month))
        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.audit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then(() => {
            this.loadList();
            this.$Message("审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    cancelAudit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const vdates = new Set(checked.map(val => val.year + "" + val.month))
        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要反审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.cancelAudit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then(() => {
            this.loadList();
            this.$Message("反审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    doUpload() {
      let layerId = layer.open({
        title: "批量导入凭证",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(VoucherImport, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList()
          }
        })
      });
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    this.params.voucherDate.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.voucherDate.end = this.params.voucherDate.start;
    this.cloneParams = clone(this.params, true);
    this.loadList();
  }
};
</script>
<style scoped>
/* jxd css样式调整 */
.h-dropdowncustom{
  margin-top: -2px;
}
</style>